var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-slide-x-transition',[(_vm.show)?_c('div',{class:{'text-xs-center': _vm.centered}},[_c('v-pagination',{ref:"pagination",staticClass:"custom-pagination-controls mt-2 mb-1",class:{'hide-icons': _vm.hideIcons},attrs:{"value":_vm.page,"circle":_vm.circle,"length":_vm.numPages},on:{"input":_vm.onPageButtonClicked}})],1):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/PaginationControls.vue?vue&type=template&id=7862c2b1&
// module id = 1983
// module chunks = 5